import { render } from "./AssistantChatBody.vue?vue&type=template&id=7fd826ee&scoped=true"
import script from "./AssistantChatBody.vue?vue&type=script&lang=js"
export * from "./AssistantChatBody.vue?vue&type=script&lang=js"

import "./AssistantChatBody.vue?vue&type=style&index=0&id=7fd826ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd826ee"]])

export default __exports__